import React from 'react';
import Icon from "./Icon";
import PropTypes from "prop-types";

const CalendarIcon = (props) => {
    const getClassName = () => {
        const btnTypeClass = props?.selected ? 'button--outline' : 'button--secondary' ;
        let className = `${(props.className || '')} button button--icon ${btnTypeClass}`;

        if(props.selected) {
            className += ' selected';
        }

        return className;
    }
    return (
        <button 
            className={getClassName()} 
            onClick={props.onClick}
        >
            <span className="sr-only">Display Events in a Calendar</span>
            <Icon
                icon='icon-calendar'
            />
        </button>
    );
}

CalendarIcon.propTypes = {
    selected: PropTypes.bool,
    onClick: PropTypes.func,
}

CalendarIcon.defaultProps = {
    selected: false,
    onClick: () => {}
}

export default CalendarIcon;
